import api from './axios';

export const getStudentProgress = (studentId, courseId) =>
  api.get(`/students/${studentId}/courses/${courseId}/progress`);

export const updateStudentProgress = (studentId, courseId, data) =>
  api.post(`/students/${studentId}/courses/${courseId}/progress`, data);